// packages/components/src/doctor-ai/LabResultTable.tsx
import React from 'react';
import { Card, Badge } from '@dopomogai/ui';
import { FileText } from 'lucide-react';
import clsx from 'clsx';
import type { LabResultData } from '@dopomogai/types'; // Assuming this type is created

export const LabResultTable: React.FC<{ data: LabResultData }> = ({ data }) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'high':
      case 'very high':
        return 'red';
      case 'low':
        return 'blue';
      default:
        return 'green';
    }
  };

  return (
    <Card noHoverEffect noPadding>
      <div className="p-5">
        <h3 className="text-lg font-bold text-slate-800">{data.title}</h3>
        <p className="text-xs text-slate-500 mt-1 flex items-center gap-1.5">
          <FileText size={12} /> Source: {data.sourceDocument}
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 text-xs text-slate-600 uppercase">
            <tr>
              <th scope="col" className="px-6 py-3">Test</th>
              <th scope="col" className="px-6 py-3 text-right">Value</th>
              <th scope="col" className="px-6 py-3">Reference Range</th>
              <th scope="col" className="px-6 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.results.map((result, index) => (
              <tr key={index} className="bg-white border-b border-slate-200 hover:bg-slate-50">
                <th scope="row" className="px-6 py-4 font-medium text-slate-900 whitespace-nowrap">
                  {result.name}
                </th>
                <td className="px-6 py-4 text-right font-mono">{result.value} <span className="text-slate-400">{result.unit}</span></td>
                <td className="px-6 py-4 text-slate-500 font-mono">{result.range}</td>
                <td className="px-6 py-4">
                  <Badge text={result.status} accentColor={getStatusColor(result.status)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};